<template>
  <expandable-material-card
    :title="$t('components.portal.portal_settings.member_registration')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="settings"
  >
    <v-card-text>
      <v-form v-model="valid" v-if="portal !== null && portal !== undefined">
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <!-- <v-select
              :label="
                $t(
                  'components.portal.portal_settings.member_registration_component'
                )
              "
              v-model="portal.memberRegistrationComponent.Name"
              class="required"
              :rules="[$rules.required]"
              :items="options.Enums.MemberRegistrationClass"
            ></v-select> -->
            <trans-enum
              :value.sync="portal.memberRegistrationComponent.Name"
              :items="options.Enums.MemberRegistrationClass"
              :label="
                $t(
                  'components.portal.portal_settings.member_registration_component'
                )
              "
              class="required"
              :rules="[$rules.required]"
            ></trans-enum>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <!-- <v-select
              :label="
                $t(
                  'components.portal.portal_settings.registration_completion_component'
                )
              "
              v-model="portal.registrationCompletionComponent.Name"
              class="required"
              :rules="[$rules.required]"
              :items="options.Enums.RegistrationCompletionClass"
            ></v-select> -->
            <trans-enum
              :value.sync="portal.registrationCompletionComponent.Name"
              :items="options.Enums.RegistrationCompletionClass"
              :label="
                $t(
                  'components.portal.portal_settings.registration_completion_component'
                )
              "
              class="required"
              :rules="[$rules.required]"
            ></trans-enum>
          </v-col>
        </v-layout>
      </v-form>
    </v-card-text>
  </expandable-material-card>
</template>

<script>
import { mapGetters } from "vuex";
import ExpandableMaterialCard from './ExpandableMaterialCard.vue';
import TransEnum from "../TransEnum.vue";

export default {
  components:{
    ExpandableMaterialCard,
    TransEnum
  },
  props: ["dataContainer"],
  data() {
    return {
      valid: true,
      portal: null,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    dataContainer: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.portal = JSON.parse(JSON.stringify(v.portal));
        }
      },
    },
    portal: {
      handler(v) {
        this.$emit("update", v);
      }, deep: true
    },
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
  },
  mounted() {
    if (this.dataContainer !== null && this.dataContainer !== undefined) {
      this.portal = JSON.parse(JSON.stringify(this.dataContainer.portal));
      this.$nextTick(() => {
        this.$emit("valid", this.valid);
      });
    }
  },
};
</script>
